import { useEffect, useRef, useContext } from 'react';

import { GlobalContext } from "../../contexts/globalContext"

import NoVideo from '../../graphics/no-video.png';
import styles from './ParticipantStreamComponent.module.css'

const ParticipantStreamComponent = (props) => {
    const { currentConference, socketRef, deskData, currentParticipant, iamSubAdministrator } = useContext(GlobalContext);

    const audioRef = useRef(null);
    const videoRef = useRef(null);
    const ref = useRef(null);


    useEffect(() => {

        const playVideosListener = function (conferenceId) {
            if (conferenceId === currentConference._id) {
                currentConference.videoPaused = false;

                if (videoRef.current.srcObject) {
                    videoRef.current.play();
                }

                ref.current.style.opacity = 1;
                ref.current.style.transform = "translate(0px, 0px)";

                if (audioRef.current.srcObject) {
                    audioRef.current.play();
                }
            }
        };

        const pauseVideosListener = function (conferenceId) {
            if (conferenceId === currentConference._id) {
                currentConference.videoPaused = true;

                if (videoRef.current.srcObject) {
                    setTimeout(() => {
                        videoRef.current.pause();
                        videoRef.current.load();
                    }, 500);
                }

                ref.current.style.opacity = 0;
                ref.current.style.transform = "translate(900px, 0px)";

                if (audioRef.current.srcObject) {
                    audioRef.current.pause();
                    audioRef.current.load();
                }
            }
        };

        socketRef.current.on('PLAY_VIDEOS', playVideosListener);
        socketRef.current.on('PAUSE_VIDEOS', pauseVideosListener);

        return () => {
            socketRef.current?.off('PLAY_VIDEOS', playVideosListener);
            socketRef.current?.off('PAUSE_VIDEOS', pauseVideosListener);
        }
    }, [])

    useEffect(() => {
        if (!props.audioStream) {
            return;
        }
        audioRef.current.srcObject = props.audioStream;
    }, [props.audioStream])

    useEffect(() => {
        if (!props.videoStream) {
            return;
        }

        setTimeout(() => {
            if (videoRef.current) {
                videoRef.current.srcObject = props.videoStream;
            }

            setTimeout(() => {
                videoRef.current?.play();
            }, 1000);
        }, 2000);

    }, [props.videoStream])

    useEffect(() => {
        setTimeout(() => {
            if (currentConference.videoPaused) {
                videoRef.current?.pause();
                videoRef.current?.load();
                if (ref.current) {
                    ref.current.style.opacity = 0;
                    ref.current.style.transform = "translate(900px, 0px)";
                }
            } else {
                if (videoRef.current?.srcObject) {
                    videoRef.current?.play();
                }
                if (ref.current) {
                    ref.current.style.opacity = 1;
                    ref.current.style.transform = "translate(0px, 0px)";
                }
            }
        }, 300);

        if (currentConference.videoPaused) {
            audioRef.current.pause();
            audioRef.current.load();
        } else {
            if (audioRef.current.srcObject) {
                audioRef.current.play();
            }
        }

        var iamModerator = (currentConference?.type === "Conference" && currentConference?.topics[0].moderator._id === currentParticipant?._id) ||
            iamSubAdministrator ||
            ((currentConference?.type === "Presentation" || currentConference?.type === "Meeting") && currentParticipant?._id === currentConference.moderatedBy);

        if (deskData && !iamModerator) {
            audioRef.current.muted = true;
        }
    }, [currentConference])

    const muteUnmute = () => {
        audioRef.current.muted = !(audioRef.current.muted);
    }

    return (
        <div ref={ref} style={{
            display: props.participant.name ? "block" : "none", position: "relative", marginTop: "10px", height: props.height, transition: "all 0.5s",
            transform: "translate(900px, 0px)", borderRadius: 10, overflow: "hidden"
        }}>
            <video ref={videoRef} className={styles.videoComp} width={1.33 * props.height} poster={NoVideo} height={props.height} onClick={() => muteUnmute()} />
            <audio ref={audioRef} ></audio>
            <div className={styles.name} style={{ width: "100%", position: "absolute", left: "0px", bottom: "-2px", color: "white", height: "auto" }} onClick={() => muteUnmute()}>
                {props.participant.name}
            </div>
        </div>

    );
}

export default ParticipantStreamComponent;